export default "__VITE_ASSET__XlOOfXFN__"